<template>
  <div class="admin-field-base">
    <v-textarea
      v-if="type === FieldTypes.TEXTAREA"
      :value="value"
      :label="label"
      auto-grow
      rows="3"
      :rules="rules"
      @input="$emit('update', { [fieldName]: $event })"
      v-bind="{ ...globalFieldAttrs, outlined: false }"
    />
    <v-text-field
      v-else-if="type === FieldTypes.NUMBER"
      :label="label"
      :value="value"
      type="number"
      :rules="rules"
      @change="$emit('update', { [fieldName]: $event })"
      v-bind="globalFieldAttrs"
    />
    <AdminFieldCheckbox
      v-else-if="type === FieldTypes.BOOLEAN"
      :Model="Model"
      :label="label"
      :id="id"
      :field-name="fieldName"
      v-bind="{ ...globalFieldAttrs, outlined: false }"
    />
    <AdminFieldMoney
      v-else-if="type === FieldTypes.MONEY"
      v-bind="globalFieldAttrs"
      :label="label"
      :field-name="fieldName"
      :value="value"
      @price="$emit('update', { [fieldName]: $event })"
    />
    <AdminFieldRelated
      v-else-if="type === FieldTypes.BELONGS_TO"
      :Model="Model"
      :id="id"
      v-bind="{ ...globalFieldAttrs, outlined: false }"
      @update="$emit('update', $event)"
    />
    <v-row v-else-if="type === FieldTypes.DATETIME" no-gutters>
      <v-input>
        <v-col class="px-0">
          <div class="mb-2 grey--text text--darken-1">{{ label }}</div>
          <AdminInputDatetime
            v-bind="{ ...globalFieldAttrs, outlined: false }"
            :timestamp="utcToLocal(value)"
            @update="$emit(`update`, localToUtc($event))"
            class="d-flex align-end"
          />
        </v-col>
      </v-input>
    </v-row>
    <div v-else-if="type === FieldTypes.SELECT">
      <v-input>
        <v-col class="pa-0">
          <div class="mb-2 grey--text text--darken-1">{{ label }}</div>
          <AdminFieldSingleSelect
            :items="header.items || []"
            :value="value"
            :width="header.width || null"
            :Model="Model"
            :id="id"
            :field-name="fieldName"
          />
        </v-col>
      </v-input>
    </div>
    <div v-else-if="type === FieldTypes.MULTISELECT">
      <v-input>
        <v-col class="px-0">
          <div class="mb-2 grey--text text--darken-1">{{ label }}</div>

          <AdminFieldMultiselect
            v-bind="{ ...globalFieldAttrs, outlined: false }"
            :value="value"
            @update="$emit(`update`, $event)"
          />
        </v-col>
      </v-input>
    </div>
    <v-text-field
      v-else
      :label="label"
      :readonly="!!header.readonly"
      :value="value"
      :rules="rules"
      v-bind="globalFieldAttrs"
      @change="$emit('update', { [fieldName]: $event })"
    />
  </div>
</template>

<script>
import { Model } from '@vuex-orm/core'
import _get from 'lodash/get'
import _includes from 'lodash/includes'
import { utcToLocal, localToUtc } from '@/utils/utcConverter'

import FieldTypes from '@/constants/FieldTypes'

import AdminFieldCheckbox from '@/components/AdminFieldCheckbox'
import AdminFieldRelated from '@/components/AdminFieldRelated'
import AdminInputDatetime from '@/components/AdminInputDatetime'
import AdminFieldSingleSelect from '@/components/AdminFieldSingleSelect'
import AdminFieldMultiselect from '@/components/AdminFieldMultiselect'
import AdminFieldMoney from '@/components/AdminFieldMoney'

export default {
  name: 'AdminFieldBase',

  components: {
    AdminFieldCheckbox,
    AdminFieldRelated,
    AdminInputDatetime,
    AdminFieldSingleSelect,
    AdminFieldMultiselect,
    AdminFieldMoney,
  },
  props: {
    Model: {
      type: Model,
      default: () => Model,
    },
    id: {
      type: [String, Number],
      default: null,
    },
    header: {
      type: Object,
      default: () => {},
    },
    fieldAttrs: {
      type: Object,
      default: () => {},
    },
    type: {
      type: String,
      default: '',
      validator: (v) => _includes(FieldTypes, v),
    },
  },
  data() {
    return {
      FieldTypes,
    }
  },
  methods: {
    localToUtc,
    utcToLocal,
    _get,
  },
  computed: {
    globalFieldAttrs() {
      const defaults = { outlined: true, dense: true }
      return { ...defaults, ...this.fieldAttrs }
    },
    item() {
      return this.Model.find(this.id) || {}
    }, // item
    label() {
      return _get(this.header, 'text', '')
    }, // label
    fieldName() {
      return _get(this.header, 'value', '')
    }, // fieldName
    value() {
      return _get(this.item, this.fieldName, '')
    }, // value
    rules() {
      return _get(this.header, 'rules', [])
    }, // rules
  },
}
</script>
